import { Helmet, HelmetProvider } from 'react-helmet-async';

import { AxiosError } from 'axios';

import { NotFound404, NotFoundProduct } from '@/pages';

import { ErrorTemplate } from './ErrorTemplate';

interface ErrorPageProps {
  error?: AxiosError | Error;
  statusCode?: number;
}

export function ErrorPage({ error, statusCode }: ErrorPageProps) {
  let title = '문제가 발생했습니다';
  let responseData: { status?: number; message?: string } = {};
  let ErrorPage: JSX.Element;
  const { message: errorMsg } = error as Error;

  if (error && (error as AxiosError).response) {
    const axiosError = error as AxiosError;
    const axiosErrorMsg = (axiosError.response?.data as { message: string })?.message;
    responseData = {
      status: axiosError.response?.status,
      message: axiosErrorMsg,
    };
    const isProduct = axiosError?.config?.url?.includes('/market/campaigns');

    switch (axiosError.response?.status) {
      case 404:
        title = isProduct ? '상품을 찾을 수 없습니다' : '페이지를 찾을 수 없습니다';
        ErrorPage = isProduct ? <NotFoundProduct /> : <NotFound404 />;
        break;
      default:
        ErrorPage = <ErrorTemplate status={responseData.status} msg={responseData.message} />;
    }
  } else {
    ErrorPage = <ErrorTemplate status={500} msg={errorMsg} />;
  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>{title}</title>
        </Helmet>
      </HelmetProvider>
      {ErrorPage}
    </>
  );
}
